'use client'

import { useContext, useMemo } from 'react'

import { useSessionStorage } from '@/app/hooks/useSessionStorage'
import { STORAGE_KEY } from '@/app/constants'
import { getPortByDomainLock, type TLocalizeVersion } from '@/app/config/ports'
import { LocalizeVersionContext } from '@/app/components/LocalizeVersionProvider'

export function useEffectiveLocalizeVersion() {
  const contextValue = useContext(LocalizeVersionContext)

  if (contextValue == null) {
    throw new Error('useEffectiveLocalizeVersion must be used within a LocalizeVersionProvider')
  }

  const [stored] = useSessionStorage<TLocalizeVersion | null>(
    STORAGE_KEY.SELECTED_LOCALIZE_VERSION,
    null
  )

  return useMemo<TLocalizeVersion>(() => {
    // Enforce domain lock (e.g., .com.br forces SANTOS)
    if (typeof window !== 'undefined') {
      const host = window.location.hostname || ''
      const lockedPort = getPortByDomainLock(host)
      if (lockedPort) {
        return lockedPort.key as TLocalizeVersion
      }
    }
    return (stored as TLocalizeVersion) || contextValue
  }, [stored, contextValue])
}
